import { useState } from "react"
import { SensorPayload } from "../../api/SensorDetailsAPIService";


interface AddSensorProps {
  onChange: (details: SensorPayload) => void;
}

export const AddSensorComponent: React.FC<AddSensorProps> = ({
  onChange
}) => {

    const [sensorDetails, setSensorDetails] = useState<SensorPayload>({
      identity: '',
      sensorType: 'Intellisense',
      isPublic: false
    });

    const handleChange = (e) => {
      const newDetails = {...sensorDetails, [e.target.name]: e.target.value};
      setSensorDetails(newDetails)
      onChange(newDetails)
    }
     
    return (<table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase dark:bg-gray-700 dark:text-gray-400">
        <tr>
            <th scope="col" className="px-6 py-3">
                Sensor Type
            </th>
            <th scope="col" className="px-6 py-3">
                Token
            </th>
            <th scope="col" className="px-6 py-3">
                Shared
            </th>
        </tr>
        </thead>
        <tbody>
        <tr className="text-center">
        <td>
        <select
          className="block rounded-lg appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-2 py-2 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
          value={sensorDetails.sensorType}
          name="sensorType"
          onChange={handleChange}
        >
          <option value="Intellisense">Intellisense</option>
          <option value="Tempest">Tempest</option>
          {/* Add more options as needed */}
        </select>
        </td>
        <td>
        <input
          className="block rounded-lg appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
          type="text"
          value={sensorDetails.identity}
          onChange={handleChange}
          name="identity"
          placeholder="Enter Sensor ID / Token"
        />
        </td>
        <td>
        <div className="relative inline-block w-10 align-middle select-none transition duration-200 ease-in">
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  value=""
                  className="sr-only peer"
                  checked={sensorDetails.isPublic}
                  name="isPublic"
                  onChange={handleChange}
                  disabled={sensorDetails.sensorType === 'Intellisense'}
                />
                <div className="w-11 h-6 bg-gray-400 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
              </label>
            </div>
        </td>
        </tr>
        </tbody>
      </table>)
  }